import apiClient from './authService';

const CHAT_STORAGE_KEY = 'mbvip_test_chat_messages';

export function sendTestInboundMessage(data) {
  return apiClient
    .post('/test/inbound-message/', {
      phone_number: data.phone_number,
      message: data.message,
      profile_name: data.profile_name,
    })
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to send message');
      }
      throw new Error('Network error');
    });
}

export function getStoredChatMessages() {
  try {
    const raw = localStorage.getItem(CHAT_STORAGE_KEY);
    if (!raw) {
      return [];
    }

    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

export function saveStoredChatMessages(messages) {
  localStorage.setItem(CHAT_STORAGE_KEY, JSON.stringify(messages));
}

export function appendStoredChatMessage(messageItem) {
  const currentMessages = getStoredChatMessages();
  const updatedMessages = [...currentMessages, messageItem];
  saveStoredChatMessages(updatedMessages);
  return updatedMessages;
}